/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormJobCategoryTypeField_viewer$ref: FragmentReference;
declare export opaque type FormJobCategoryTypeField_viewer$fragmentType: FormJobCategoryTypeField_viewer$ref;
export type FormJobCategoryTypeField_viewer = {|
  +jobCategoryTypes: ?$ReadOnlyArray<?{|
    +id: string,
    +plainId: ?string,
    +name: ?string,
    +label: ?string,
  |}>,
  +$refType: FormJobCategoryTypeField_viewer$ref,
|};
export type FormJobCategoryTypeField_viewer$data = FormJobCategoryTypeField_viewer;
export type FormJobCategoryTypeField_viewer$key = {
  +$data?: FormJobCategoryTypeField_viewer$data,
  +$fragmentRefs: FormJobCategoryTypeField_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "FormJobCategoryTypeField_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "businessTypeName",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "jobCategoryTypes",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "businessTypeName",
          "variableName": "businessTypeName"
        }
      ],
      "concreteType": "JobCategoryType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "plainId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "label",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b6a71003a32e33c6fc3498f96cb00c7e';
module.exports = node;
